// Copyright © Veeam Software Group GmbH

export enum SubheaderType {
    Default,
    LargeNumbersOfItems,
    SearchIsUsed,
    LimitIsReached,
}
